// src/guards/adminGate.tsx

import React from 'react';
export function withAdminGate<T>(Comp: React.ComponentType<T>) {
  return function Gate(props: T) {
    const [ok, setOk] = React.useState(false);
    const [pin, setPin] = React.useState('');
    React.useEffect(() => {
      const stored = sessionStorage.getItem('admin_ok');
      if (stored === '1') setOk(true);
    }, []);
    if (!ok) {
      return (
        <div className="min-h-screen grid place-items-center p-6">
          <div className="max-w-sm w-full space-y-3">
            <h1 className="text-xl font-semibold">Admin Access</h1>
            <input className="border rounded w-full p-2" placeholder="Enter PIN" value={pin} onChange={e=>setPin(e.target.value)} />
            <button
              className="w-full border rounded p-2"
              onClick={async ()=>{
                const r = await fetch('/api/seo?action=getBundle&pin='+encodeURIComponent(pin));
                if (r.ok) { sessionStorage.setItem('admin_ok','1'); setOk(true); }
                else alert('Invalid PIN');
              }}
            >Enter</button>
            <p className="text-xs text-gray-500">This page is hidden and set to noindex.</p>
          </div>
        </div>
      );
    }
    return <Comp {...props} />;
  };
}